export enum IpoPricedOption {
  BelowRange = 'Below Range',
  WithinRange = 'Within Range',
  AboveRange = 'Above Range',
  All = '',
}
